import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import goToMaterialPage from "./goToMaterialPage";
import {showMaterialsTutorial} from "../../actions/tutorialFunctions";
import {toggleBathroomVisualizerOpen} from "../../actions/actionFunctions";

class MinimizeButton extends React.Component {

  componentWillReceiveProps(nextProps) {
    if (nextProps.visualizerTutorialStep === 1 && !this.props.visualizerTutorialStep) {
      this.backToQuote();
    }
  }

  backToQuote = () => {
    goToMaterialPage('visualizer');
    this.props.toggleBathroomVisualizerOpen(false);
    if (!this.props.materialsTutorialFinished) {
      this.props.showMaterialsTutorial(true);
    }
  };

  render() {
    return (
      <button className="mobilebutton mobilebutton--back-to-quote" onClick={this.backToQuote}>
        <span className="mobilebutton-text"><FormattedMessage id="quoteButton"/></span>
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
    materialsTutorialFinished: store.tutorialState.materialsTutorialFinished,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  showMaterialsTutorial
})(MinimizeButton);
